<template lang="pug">
    div(:class="'context-'+context")
        include LastNews.pug
</template>

<script>
import _ from "underscore"
import { mapState } from 'vuex'
import Api from "@/components/services/Api"

export default {
  name: 'LastNews',
  computed: mapState([
    "context",
  ]),
  data () {
    return {
      entries: [],
    }
  },
  created() {
    const _this = this;
    const token = this.$store.state.token;

    this.$wagtail.getEntries("noticias", true).then(response => {
      let data = response.data
      _this.entries = data.results.slice(0, 3)
    })
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "LastNews";
.context-colreps {
    @import "LastNewsColreps";
}
</style>




// WEBPACK FOOTER //
// src/components/lastnews/LastNews.vue